// Swiped from here: https://stackoverflow.com/questions/14226803/wait-5-seconds-before-executing-next-line

export default function sleep(delayInMs: number): Promise<void> {
    return new Promise(res => setTimeout(res, delayInMs));
}
